// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableBox[data-v-10985604]{height:calc(100% - 260px)}.colorStyle[data-v-10985604]{color:red}.formbox[data-v-10985604] ,.headebut[data-v-10985604]{width:80%;margin:0 auto}.headebut[data-v-10985604]{padding-left:100px;box-sizing:border-box}.el-range-separator[data-v-10985604] {line-height:22px}.el-date-editor[data-v-10985604] .el-range__icon{line-height:25px}", ""]);
// Exports
module.exports = exports;
